import { SYNDIGO_SCRIPT, SYNDIGO_SITE_ID } from './constants'

export const formatProductId = productId => productId
  .replace(/^0+(?!$)/, '')
  .replace('-BOT', '')

export const loadSyndigoScript = (callback) => {
  const cache = Math.floor(Date.now() / 86400000)
  const existingScript = document.getElementById(SYNDIGO_SCRIPT)

  if (!existingScript) {
    const scriptElement = document.createElement('script')
    scriptElement.id = SYNDIGO_SCRIPT
    scriptElement.type = 'text/javascript'
    scriptElement.sync = true
    scriptElement.src = `https://content.syndigo.com/site/${SYNDIGO_SITE_ID}/tag.js?cv=${cache}`
    scriptElement.onload = () => callback()

    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(scriptElement, firstScriptTag)
  }

  Boolean(existingScript) && callback && callback()
}
